import { render, staticRenderFns } from "./questionPublic.vue?vue&type=template&id=f475a468&scoped=true&"
import script from "./questionPublic.vue?vue&type=script&lang=js&"
export * from "./questionPublic.vue?vue&type=script&lang=js&"
import style0 from "./questionPublic.vue?vue&type=style&index=0&id=f475a468&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f475a468",
  null
  
)

export default component.exports